import type { FC } from "react";
import { ChangeEvent } from "react";
import { Input } from "@renewmap/ui/input";
import { Label } from "@renewmap/ui/label";
import { Switch } from "@renewmap/ui/switch";

export interface TableControlsProps {
  loading: boolean;
  setQuickSearch: (value: string) => void;
  showAllColumns?: boolean;
  setShowAllColumns?: (value: boolean) => void;
}

export const TableControls: FC<TableControlsProps> = ({
  loading,
  setQuickSearch,
  showAllColumns,
  setShowAllColumns,
}) => {
  const quickFilterChanged = (e: ChangeEvent<HTMLInputElement>) => {
    setQuickSearch(e.target.value);
  };

  return (
    <div className="flex items-center space-x-2">
      {showAllColumns !== undefined && setShowAllColumns && (
        <div className="width-42 flex gap-2 pt-1">
          <Switch
            checked={showAllColumns}
            onCheckedChange={setShowAllColumns}
          />
          <Label>Show all columns</Label>
        </div>
      )}
      <Input
        disabled={loading}
        className="ml-auto h-8 w-[15%] min-w-52"
        placeholder="Find..."
        onChange={quickFilterChanged}
      />
    </div>
  );
};
